import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { UsersProvider } from '../../providers/users/users';
import { AwsProvider } from '../../providers/aws/aws';
import { EditUserPage } from '../edit-user/edit-user';
import { EditEndpointsPage } from '../edit-endpoints/edit-endpoints';
import { AddBviLeadsPage } from '../add-bvi-leads/add-bvi-leads';
import { AgencySetupPage } from '../agency-setup/agency-setup';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

/**
 * This page should display the current user's User attributes & registration status, 
 * & list their campaigns. Near the User record should be a link or button to edit or add to that.
 * Each campaign should have edit and cancel links. And there should be an "Add campaign" button.
 */

@IonicPage()
@Component({
  selector: 'page-user-overview',
  templateUrl: 'user-overview.html',
})
export class UserOverviewPage {

	userPassed: object;
	userRecord: any;
  sortedUserAttributes: Array<string>;
  manualUserAttributes: Array<string> = [ "firstName", "lastName", "email", "cellPhone", "companyAddress", "companyAddress2", "companyCity", "companyName", "companyPhone", "companyState", "companyURL", "companyZip", "companyUrl", "objectId" ];
  userEditable: any;
  userReadOnly: any;
	userArr: Array<object> = [];
  userNotes: string;
  showNotesPopup: boolean = false;
	cognitoId: string;
	fullname: string;
	objectKeys: Array<string> = [];
  hasChargify: string;
  //keyArray: Array<string>;

  constructor(public navCtrl: NavController, public navParams: NavParams, public usersPro: UsersProvider, public loadingCtrl: LoadingController, private aws: AwsProvider, private iab: InAppBrowser) {
  }

  // Use ionViewWillEnter so the page loads fresh each time & edits are displayed
  ionViewWillEnter(){
    console.log("loading");
    this.userPassed = this.navParams.get('user');
    this.populateData(this.userPassed['cognitoId']);
  }

  // TO DO: Push the individual attribues/values onto the array instead of the whole object, so that it can be sorted
  // Use 2 arrays: editable attributes & read-only, which will be displayed below the editable ones, separated by a line
  populateData(cognitoId: string){
    this.userArr = [];
    let loading: Loading = this.loadingCtrl.create({});
    loading.present();
    this.cognitoId = cognitoId;
  	this.usersPro.getUser(cognitoId)
    .then(record => {
  		this.userRecord = record;
      this.sortedUserAttributes = Object.keys(record).sort();
      for(let i=0; i<this.manualUserAttributes.length; i++){
        let sortedIndex = this.sortedUserAttributes.indexOf(this.manualUserAttributes[i]);
        if(sortedIndex !== -1){
          this.sortedUserAttributes.splice(sortedIndex, 1);
        }
      }
      this.hasChargifyAccount();
      // Push the object onto an array so it can be traversed in a specific way on user-overview 
  		this.userArr.push(this.userRecord);
      this.usersPro.getNotes(this.userRecord['objectId'])
      .then(notes => {
        if(notes != null){
          this.userNotes = notes;
        }else{
          this.userNotes = "";
        }
        loading.dismiss();
      });
  	});
  }

  editUser(){
    this.navCtrl.push(EditUserPage, { 
      'cognitoId': this.userPassed['cognitoId'],
      'userRecord': this.userRecord });
  }

  editEndpoints(){
    this.navCtrl.push(EditEndpointsPage, { 
      'userRecord': this.userRecord });
  }

  setUpAgency(){
    this.navCtrl.push(AgencySetupPage, { 
      'userRecord': this.userRecord });
  }

  editNotes(){
    this.showNotesPopup = true;
  }

  closeNotesPopup() {
    this.showNotesPopup = false;
  }

  addBviLeads(){
    this.navCtrl.push(AddBviLeadsPage, { 
      'userRecord': this.userRecord });
  }

  disableUser(){
    /* Update the userId value of the CognitoIdToUser record with email = admin@sherloq.co
with the value of this userId. */
    this.usersPro.disableUser(this.cognitoId, this.userRecord)
    .then((result) => {
      console.log("The user was disabled."); 
    });
  }

  enablePipl(){
    /* Update the userId value of the CognitoIdToUser record with email = admin@sherloq.co
with the value of this userId. */
    this.usersPro.enablePipl(this.userRecord['objectId'])
    .then((result) => {
      this.populateData(this.cognitoId);
      console.log("Piple has been enabled."); 
    });
  }

  hasChargifyAccount(){ 
    if(this.userRecord.hasOwnProperty('chargifyId') && this.userRecord.hasOwnProperty('subscriptionId')){
      this.hasChargify = "has";
    }else{
      this.hasChargify = "does not have";
    }
  }

  imposterLogin(){
    /* Update the userId value of the CognitoIdToUser record with email = admin@sherloq.co
with the value of this userId. */
    this.usersPro.imposterLogin(this.userRecord['objectId']).then((result) => {
      if(result['success']){
        // Launch the dashboard in a new window when success is returned.
        const url = this.aws.isLive() ? 'https://bigvoodoo.sherloq.co/' : 'http://sherloq-webapp-dev.s3-website-us-east-1.amazonaws.com/';
        this.iab.create(url,'_blank',{location:'no'}); 
      }else{
        console.log("You did not get a success response.");
      }
    });
  }

  /**
   * Returns true if var is a non-null object, otherwise returns false
   */
  isObject(var2check: any){
    if(typeof var2check === 'object' && var2check !== null && var2check !== undefined){
      this.objectKeys = this.generateArray(var2check);
      return true;
    }else{
      return false;
    }
  }

  /**
   * Takes an object & returns an array of its keys
   */
  generateArray(obj){
    return Object.keys(obj);
    //.map((key)=>{ return obj[key]});
  }

  // change the lambda so it returns the new record then just update this.userNotes w/ the return value.
  submitNotes(){
    this.usersPro.updateNotes(this.userRecord['objectId'], this.userNotes).then(() => {
        this.usersPro.getNotes(this.userRecord['objectId'])
        .then(notes => {
          this.userNotes = notes;
          this.showNotesPopup = false;
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-overview/user-overview.ts